import React, { useContext } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import GroupDCT from "../FieldTags/GroupDCT";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const dctProgrammer = [
    "Aaron Gannon",
    "Blanca Obregon",
    "Jared Hennessy",
    "Jesse Forrest",
];

const ValidationBy = ({ validationBy, handleChange, pullLists, informedConsent, informedConsentApprover, shipmentFromRepo, sampleDisposal }) => {
    const { user } = useContext(UserContext);
    const canEdit = ((shipmentFromRepo === "No" && sampleDisposal === "No") || (informedConsent !== "No" && informedConsentApprover !== "No")) && checkRole(user, [ROLES.DCT]);

    return (
        <div className="planField">
            <GroupDCT />
            <FormControl variant="standard">
                <InputLabel shrink={true}>{pullListLabels.validationBy}</InputLabel>
                <Select
                    id="validationBy-field"
                    name="validationBy"
                    notched={true}
                    value={validationBy ? validationBy : ""}
                    onChange={(e) => handleChange("validationBy", e.target.value)}
                    disabled={!canEdit}
                >
                    {dctProgrammer.map((name) => (
                        <MenuItem key={name} value={name}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"validationBy"} />
        </div>
    );
};

export default ValidationBy;